import { Button } from 'antd';
import React from 'react';

const NotFoundPage = () => {

    const onClickBtnRetornar = () => {
        window.location.href = "/";
    }

    return (
        <div>
            Pagina no encontrada!
            <br />
            <Button type='link' onClick={onClickBtnRetornar}>
                Retornar
            </Button>
        </div >
    );
};

export default NotFoundPage;